var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLpFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1667 6.08334H18.5C16.8645 6.08334 15.296 6.72426 14.1395 7.86511C12.983 9.00596 12.3333 10.5533 12.3333 12.1667V60.8334C12.3333 62.4468 12.983 63.9941 14.1395 65.1349C15.296 66.2758 16.8645 66.9167 18.5 66.9167H55.5C57.1355 66.9167 58.704 66.2758 59.8605 65.1349C61.017 63.9941 61.6667 62.4468 61.6667 60.8334V24.3333L43.1667 6.08334Z",
    fill: "#6D0062",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1667 6.08334V24.3333H61.6667",
    fill: "#6D0062"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1667 6.08334V24.3333H61.6667",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3333 39.5417H24.6667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3333 51.7083H24.6667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8333 27.375H27.75H24.6667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpFile);
export default __webpack_public_path__ + "static/media/LPFile.4825a33bb2855ed01b1394fa773c86f0.svg";
export { ForwardRef as ReactComponent };